import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface ProspectTradingNoticeProps {
  className?: string;
}

/**
 * Shown in place of buying and selling controls on a prospect account.
 *
 * Prospects browse real wines against demonstration holdings, so there is no
 * physical stock behind an asset unit and nothing to trade. Explaining that -
 * and pointing at the way to open a real account - reads better than controls
 * that silently vanish, and it is the point of the preview.
 *
 * Presentation only. The API refuses these actions for a prospect whether or not
 * this component is rendered.
 */
const ProspectTradingNotice: FC<ProspectTradingNoticeProps> = ({ className = '' }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`rounded-2xl border border-dashed border-gray-300 dark:border-slate-600 px-4 py-3 text-center ${className}`}
    >
      <div className="text-sm font-semibold text-gray-900 dark:text-white">
        {t('product:prospect.tradingUnavailableTitle', 'Trading is not available on a preview account')}
      </div>
      <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">
        {t(
          'product:prospect.tradingUnavailableBody',
          'Speak to your relationship manager to open an account and start trading.',
        )}
      </div>
    </div>
  );
};

export default ProspectTradingNotice;
